/*
Hydration bundle for the doc site. `bundleEntry` REPLACES tosijs-ui's published
iife — it does not extend it — so this file must register everything the pages
need. Miss an import and pages serve 200 with no header, no nav, and no live
examples, and nothing errors.
*/
import 'tosijs-ui'
import 'tosijs-ui/doc-browser'
import 'tosijs-ui/doc-system/doc-system'
import 'tosijs-ui/live-example'
import * as tosijs from 'tosijs'
import * as tosijsUi from 'tosijs-ui'
import * as tosijsSchema from 'tosijs-schema'
import * as tosijsVirta from '../src/index'

// The context map is how `import … from 'tosijs-virta'` resolves inside a live
// example: the published specifier, pointed at the working tree at dev time.
for (const el of Array.from(document.querySelectorAll('tosi-doc-system'))) {
  ;(el as any).context = {
    tosijs,
    'tosijs-ui': tosijsUi,
    'tosijs-schema': tosijsSchema,
    'tosijs-virta': tosijsVirta,
  }
}
